<template>
  <el-container>
    <el-aside>
      <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
               background-color="#515868" text-color="#ffffff" active-text-color="#ffffff">
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-mobile-phone"></i>
            <span>Add Device</span>
          </template>
          <el-menu-item-group title="">
            <el-menu-item index="1-1"><i class="el-icon-arrow-right"></i>Gate Way</el-menu-item>
            <el-menu-item index="1-2"><i class="el-icon-arrow-right"></i>Forwarder</el-menu-item>
            <el-menu-item index="1-3"><i class="el-icon-arrow-right"></i>Sensor</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="2">
          <i class="el-icon-setting"></i>
          <span>Settings 2</span>
        </el-menu-item>
        <el-menu-item index="3">
          <i class="el-icon-setting"></i>
          <span>Settings 3</span>
        </el-menu-item>
        <el-menu-item index="4">
          <i class="el-icon-setting"></i>
          <span>Settings 4</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-main style="color: white;background-color: #3b3f48">
      <div>
        <add-device style=""></add-device>
      </div>

    </el-main>
  </el-container>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import ElMain from "element-ui/packages/main/src/main";
    import AddDevice from "./Device/addDevice";

    export default {
      components: {
        AddDevice,
        ElMain,
        ElContainer},
      name: "settings"
    }
</script>

<style lang="scss" scoped>
  @import url("//unpkg.com/element-ui@2.2.2/lib/theme-chalk/index.css")
</style>



// WEBPACK FOOTER //
// src/views/settings/Settings.vue